import createCachedSelector from "re-reselect";

const emptyArray = [];
const defaultMonthlyObligations = {
  isLoaded: false
};

export const getMonthlyObligations = (state, partnerId) => {
  const partnerMonthlyObligationsData = state.entities.offerPartnerMonthlyObligations[partnerId];
  return partnerMonthlyObligationsData ? partnerMonthlyObligationsData.monthlyObligations : emptyArray;
};
const getMonthlyObligationsData = (state, partnerId) =>
  state.currentOffer.clientMonthlyObligationsData.monthlyObligations[partnerId] || defaultMonthlyObligations;

export const getMonthlyObligationsIsLoaded = createCachedSelector(getMonthlyObligationsData, monthlyObligations => {
  return monthlyObligations.isLoaded;
})((_, partnerId) => partnerId);

export const getOfferPartnerMonthlyObligations = createCachedSelector(
  getMonthlyObligationsIsLoaded,
  getMonthlyObligations,
  (isLoaded, monthlyObligations) => {
    if (!isLoaded) {
      return emptyArray;
    }
    return monthlyObligations;
  }
)((_, partnerId) => partnerId);
